import React from "react";
import { isMobile } from "../../helpers/utils";
import "./style.css";
import "./mobileStyle.css";


const webContent = (label, callBack, category, enabled, keyvalue, headerText) => {
  const checkId = `${category}_${keyvalue}_${headerText}`;
  return (

    <div className="category-items" >
      <input type="checkbox"
        className="CheckBox-align-css"
        tabIndex={0}
        id={checkId}
        checked={enabled}
        onChange={() => { callBack() }}
        onKeyPress={(e) => {
          var code = (e.keyCode ? e.keyCode : e.which);
          if (code === 13) {
            callBack();
          }
        }}
        aria-label={headerText + ` alert for ` + category + ` at ` + label}
      ></input>
      <label htmlFor={checkId}>
        {label}
      </label>

    </div>
  )
}

const content = (src, label, callBack, category, enabled, keyvalue, headerText) => (
  <div className="mobile-category-items category-items" >
    <button
      tabIndex={0}
      className="noBorder"
      onClick={() => {
        if (isMobile()) {
          callBack()
        }
      }
      }
      aria-label={headerText + ` alert for ` + category + ` at ` + label + ` toggle`}
    >
      <img
        src={`/images/${src}`}
        alt={category + ` ` + label + (enabled ? ` selected` : ` not-selected`)}
      />
    </button>
    <div>
      <label>
        {label}
      </label>
    </div>
  </div>
);

const Checkbox = props => {
  const { keyvalue, verified, enabled, label, callBack, category, headerText } = props;
  const checkboxImages = [
    "checkbox-locked.png",
    "checkbox-selected.png",
    "checkbox-empty.png"
  ];
  const switchButtons = ["SwitchLock.png", "SwitchOn.png", "SwitchOff.png"];
  const images = isMobile() ? switchButtons : checkboxImages;

  if (!verified) {
    return null;
  }
  return isMobile() ?
    (enabled
      ? content(images[1], label, callBack, category, enabled, keyvalue, headerText)
      : content(images[2], label, callBack, category, enabled, keyvalue, headerText))
    :
    (enabled
      ? webContent(label, callBack, category, enabled, keyvalue, headerText)
      : webContent(label, callBack, category, enabled, keyvalue, headerText))

};
export default Checkbox;
